export const toNumberFormat = (value = 0) => {
  const vInt = parseInt(value);

  return !isNaN(vInt) || value !== null ? Number(vInt).toLocaleString() : "-";
};
